import { render } from "./PageDetails.vue?vue&type=template&id=c074127a"
import script from "./PageDetails.vue?vue&type=script&lang=js"
export * from "./PageDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__